import { createReducer } from '@reduxjs/toolkit'
import * as financialExposuresActions from '../actions/financialExposures'
import { APIData, APIStatus } from '../axiosConfiguration'
import { FinancialExposureData } from '../type/financialExposures'

type financialExposureState = {
  exposures: APIData<FinancialExposureData>
}

const initialState: financialExposureState = {
  exposures: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(financialExposuresActions.getFinancialExposures.fulfilled, (state, action) => {
      state.exposures.status = APIStatus.FULFILLED
      state.exposures.data = action.payload
    })
    .addCase(financialExposuresActions.getFinancialExposures.rejected, (state, action) => {
      state.exposures.status = APIStatus.REJECTED
      state.exposures.error = action.payload
    })
    .addCase(financialExposuresActions.getFinancialExposures.pending, (state) => {
      state.exposures.status = APIStatus.PENDING
    })
})
